export { S3ExpressIdentityCache } from "./classes/S3ExpressIdentityCache";
export { S3ExpressIdentityCacheEntry } from "./classes/S3ExpressIdentityCacheEntry";
export { S3ExpressIdentityProviderImpl } from "./classes/S3ExpressIdentityProviderImpl";
export { SignatureV4S3Express } from "./classes/SignatureV4S3Express";
export { NODE_DISABLE_S3_EXPRESS_SESSION_AUTH_OPTIONS } from "./constants";
export { getS3ExpressPlugin, s3ExpressMiddleware, s3ExpressMiddlewareOptions } from "./functions/s3ExpressMiddleware";
